import { connect } from 'react-redux';

import { getSelectOptions } from 'src/reducers/selectOptions';
import EmployeeLeaveOfAbsenceItem from '../components/EmployeeLeaveOfAbsenceItem';

export default connect(state => ({
  leaveOfAbsenceReasonTypes: getSelectOptions(state, 'leaveOfAbsenceReasonTypes')
}))(EmployeeLeaveOfAbsenceItem);
